import Section from "components/molecules/section";
import { BannerSlider } from "components/organisms";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

const PoliticaCookies = () => {
  const { t } = useTranslation();

  const banner_data_centrado = [
    {
      id: 1,
      titulo: t("cookiesPrivacyPolicy.title"),
      subtitulo: "",
      color_fondo_logo: "rgba(62, 145, 41, 1)",
      img_desktop: {
        name: "banner-politicas-cookies",
        path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/c9c6116d-b559-445b-b8c3-3b6dd38656a2.jpg",
        width: 1440,
        height: 400,
        size: 794666,
        title: "Banner Políticas de cookies",
        alt: "Banner Políticas de cookies",
        description: null,
        caption: "Banner Políticas de cookies",
      },
      img_mobile: [],
      descuento: "",
      descripcion_boton: "",
      redireccion_boton: "",
      img_logos: [],
      tipo_banner: {
        id: 1,
        titulo: "landings",
      },
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BannerSlider data={banner_data_centrado} gradiente />
      <Section>
        <div className="politicas_cookies">
          <p>{t("cookiesPrivacyPolicy.text1")}</p>
          <ul>
            <li>casa-andina.com</li>
            <li>life.casa-andina.com</li>
          </ul>
          <p>{t("cookiesPrivacyPolicy.text2")}</p>
          <p>{t("cookiesPrivacyPolicy.text3")}</p>

          <p className="text-bold">{t("cookiesPrivacyPolicy.text4")}</p>
          <p>{t("cookiesPrivacyPolicy.text5")}</p>

          <p className="text-bold">{t("cookiesPrivacyPolicy.text6")}</p>
          <p>{t("cookiesPrivacyPolicy.text7")}</p>
          <ul>
            <li>{t("cookiesPrivacyPolicy.text8")}</li>
            <li>{t("cookiesPrivacyPolicy.text9")}</li>
            <li>{t("cookiesPrivacyPolicy.text10")}</li>
            <li>{t("cookiesPrivacyPolicy.text11")}</li>
          </ul>
          <br />

          <p className="text-bold">{t("cookiesPrivacyPolicy.text12")}</p>
          <p>{t("cookiesPrivacyPolicy.text13")}</p>
          <p>{t("cookiesPrivacyPolicy.text14")}</p>
          <ul>
            <li><b>{t("cookiesPrivacyPolicy.text15")}</b> {t("cookiesPrivacyPolicy.text16")}</li>
            <li><b>{t("cookiesPrivacyPolicy.text17")}</b> {t("cookiesPrivacyPolicy.text18")}</li>
          </ul>
          <p>{t("cookiesPrivacyPolicy.text19")}</p>
          <ul>
            <li><b>{t("cookiesPrivacyPolicy.text20")}</b> {t("cookiesPrivacyPolicy.text21")}</li>
            <li><b>{t("cookiesPrivacyPolicy.text22")}</b> {t("cookiesPrivacyPolicy.text23")}</li>
            <li><b>{t("cookiesPrivacyPolicy.text24")}</b> {t("cookiesPrivacyPolicy.text25")}</li>
          </ul>
          <p>{t("cookiesPrivacyPolicy.text26")}</p>
          <ul>
            <li><b>{t("cookiesPrivacyPolicy.text27")}</b> {t("cookiesPrivacyPolicy.text28")}</li>
            <li><b>{t("cookiesPrivacyPolicy.text29")}</b> {t("cookiesPrivacyPolicy.text30")}</li>
          </ul>
          <br />

          <p>{t("cookiesPrivacyPolicy.text31")}</p>

          <ul>
            <li><b>Website:</b> casa-andina.com</li>
          </ul>

          <table>
            <thead>
              <tr>
                <th>{t("cookiesTable.category")}</th>
                <th>{t("cookiesTable.provider")}</th>
                <th>{t("cookiesTable.cookieName")}</th>
                <th>{t("cookiesTable.purpose")}</th>
                <th>{t("cookiesTable.duration")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Analytics</td>
                <td>_ga, _ga_*</td>
                <td>{t("cookiesTable.rows.0.purpose")}</td>
                <td>2 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Analytics</td>
                <td>_gid</td>
                <td>{t("cookiesTable.rows.1.purpose")}</td>
                <td>24 {t("cookiesTable.hours")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Ads</td>
                <td>_gac_UA-*</td>
                <td>{t("cookiesTable.rows.2.purpose")}</td>
                <td>4 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Hotjar</td>
                <td>_hjSession_*, _hjSessionUser_*</td>
                <td>{t("cookiesTable.rows.3.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Facebook</td>
                <td>_fbp</td>
                <td>{t("cookiesTable.rows.4.purpose")}</td>
                <td>3 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Google Ads</td>
                <td>_gcl_au, _gcl_aw, _gcl_gs</td>
                <td>{t("cookiesTable.rows.5.purpose")}</td>
                <td>3 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Google Marketing Platform</td>
                <td>ar_debug</td>
                <td>{t("cookiesTable.rows.6.purpose")}</td>
                <td>1 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>TikTok</td>
                <td>_tt_enable_cookie, _ttp, ttcsid*</td>
                <td>{t("cookiesTable.rows.7.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Criteo</td>
                <td>Criteo</td>
                <td>{t("cookiesTable.rows.8.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.functional")}</td>
                <td>Casa Andina</td>
                <td>cebs, cebsp_</td>
                <td>{t("cookiesTable.rows.9.purpose")}</td>
                <td>{t("cookiesTable.session")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.functional")}</td>
                <td>Wisepops</td>
                <td>wisepops</td>
                <td>{t("cookiesTable.rows.10.purpose")}</td>
                <td>{t("cookiesTable.variable")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.functional")}</td>
                <td>LinkedIn</td>
                <td>bcookie</td>
                <td>{t("cookiesTable.rows.11.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>LinkedIn</td>
                <td>ar_debug</td>
                <td>{t("cookiesTable.rows.12.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />

          <ul>
            <li><b>Website:</b> life.casa-andina.com</li>
          </ul>

          <table>
            <thead>
              <tr>
                <th>{t("cookiesTable.category")}</th>
                <th>{t("cookiesTable.provider")}</th>
                <th>{t("cookiesTable.cookieName")}</th>
                <th>{t("cookiesTable.purpose")}</th>
                <th>{t("cookiesTable.duration")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Analytics</td>
                <td>_ga, _ga_*</td>
                <td>{t("cookiesTable.rows.0.purpose")}</td>
                <td>2 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Analytics</td>
                <td>_gid</td>
                <td>{t("cookiesTable.rows.1.purpose")}</td>
                <td>24 {t("cookiesTable.hours")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Google Ads</td>
                <td>_gac_UA-*</td>
                <td>{t("cookiesTable.rows.2.purpose")}</td>
                <td>4 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Crazy Egg</td>
                <td>_ce.clock_data, _ce.s</td>
                <td>{t("cookiesTable.rows.13.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.analytic")}</td>
                <td>Hotjar</td>
                <td>_hjSession_*, _hjSessionUser_*</td>
                <td>{t("cookiesTable.rows.3.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Facebook</td>
                <td>_fbp</td>
                <td>{t("cookiesTable.rows.4.purpose")}</td>
                <td>3 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Google Ads</td>
                <td>_gcl_au, _gcl_aw, _gcl_gs</td>
                <td>{t("cookiesTable.rows.5.purpose")}</td>
                <td>3 {t("cookiesTable.months")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>TikTok</td>
                <td>_tt_enable_cookie, _ttp, ttcsid*</td>
                <td>{t("cookiesTable.rows.7.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.advertising")}</td>
                <td>Criteo</td>
                <td>cto_bundle</td>
                <td>{t("cookiesTable.rows.14.purpose")}</td>
                <td>1 {t("cookiesTable.years")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.functional")}</td>
                <td>Casa Andina</td>
                <td>cebs, cebsp_</td>
                <td>{t("cookiesTable.rows.9.purpose")}</td>
                <td>{t("cookiesTable.session")}</td>
              </tr>
              <tr>
                <td>{t("cookiesTable.functional")}</td>
                <td>Wisepops</td>
                <td>wisepops</td>
                <td>{t("cookiesTable.rows.10.purpose")}</td>
                <td>{t("cookiesTable.variable")}</td>
              </tr>
            </tbody>
          </table>

          <br />

          <p>{t("cookiesPrivacyPolicy.text32")}</p>

          <p className="text-bold">{t("cookiesPrivacyPolicy.text33")}</p>
          <p>{t("cookiesPrivacyPolicy.text34")}</p>
          <p>{t("cookiesPrivacyPolicy.text35")}</p>
          <ul>
            <li>Internet Explorer</li>
            <li>Safari</li>
            <li>Mozilla Firefox</li>
            <li>Opera</li>
            <li>Chrome</li>
          </ul>

          <p className="text-bold">{t("cookiesPrivacyPolicy.text36")}</p>
          <p>{t("cookiesPrivacyPolicy.text37")}</p>
          <p>{t("cookiesPrivacyPolicy.text38")}</p>


          <p className="text-bold">{t("cookiesPrivacyPolicy.text39")}</p>
          <p>{t("cookiesPrivacyPolicy.text40")}</p>
          <p>{t("cookiesPrivacyPolicy.text41")}</p>

          
          <p className="text-bold">{t("cookiesPrivacyPolicy.text42")}</p>
          <p>{t("cookiesPrivacyPolicy.text43")}</p>
        </div>
      </Section>
    </>
  );
};

export default PoliticaCookies;
